// --------------------------------------------------------
// src/views/searchFilter.view.js
//
// Manage the filters after the user searches for a book
// using keywords
//
// --------------------------------------------------------
"use strict";

const SEARCH_FILTER_TEMPLATE = `
	<nav id="search-filters">
        <ul class="p0">
            <li data-attribute="theme"><%= app.localeManager.get("filters.theme") %><i class="fa fa-caret-down" aria-hidden="true"></i>
            <ul class="p0">
            <% for (var i = 0; i < this.collection.themes().length; i++) { %>
                <% if (this.collection.themes()[i] !== null) { %>
                <li data-value="<%= this.collection.themes()[i].name %>">
                <i class="fa fa-square-o" aria-hidden="true"></i>
                <%= app.localeManager.get("themes." + this.collection.themes()[i].name.toLowerCase()) %>
                <span>(<%= this.collection.filterBy("theme", [this.collection.themes()[i].name]).length %>)</span>
                </li>
                <% } %>
            <% } %>
            </ul>
            </li>
        </ul>
        <ul class="p0">
            <li data-attribute="language"><%= app.localeManager.get("filters.language") %><i class="fa fa-caret-down" aria-hidden="true"></i>
            <ul class="p0">
            <% for (var i = 0; i < this.collection.languages().length; i++) { %>
                <% if (this.collection.languages()[i] !== null) { %>
                <li data-value="<%= this.collection.languages()[i] %>">
                <i class="fa fa-square-o" aria-hidden="true"></i>
                <%= app.localeManager.get("languages." + this.collection.languages()[i].toLowerCase()) %>
                <span>(<%= this.collection.filterBy("language", [this.collection.languages()[i]]).length %>)</span>
                </li>
                <% } %>
            <% } %>
            </ul>
            </li>
        </ul>
        <ul class="p0">
            <li data-attribute="country"><%= app.localeManager.get("filters.country") %><i class="fa fa-caret-down" aria-hidden="true"></i>
            <ul class="p0">
            <% for (var i = 0; i < this.collection.countries().length; i++) { %>
                <% if (this.collection.countries()[i] !== null) { %>
                <li data-value="<%= this.collection.countries()[i] %>">
                <i class="fa fa-square-o" aria-hidden="true"></i>
                <%= app.localeManager.get("country." + this.collection.countries()[i].toLowerCase()) %>
                <span>(<%= this.collection.filterBy("country", [this.collection.countries()[i]]).length %>)</span>
                </li>
                <% } %>
            <% } %>
            </ul>
            </li>
        </ul>
        <ul class="p0">
            <li data-attribute="reading_level"><%= app.localeManager.get("filters.level") %><i class="fa fa-caret-down" aria-hidden="true"></i>
            <ul class="p0">
            <% for (var i = 0; i < this.collection.levels().length; i++) { %>
                <% if (this.collection.levels()[i] !== null) { %>
                <li data-value="<%= this.collection.levels()[i] %>">
                <i class="fa fa-square-o" aria-hidden="true"></i>
                <%= app.localeManager.get("levels." + this.collection.levels()[i].toLowerCase()) %>
                <span>(<%= this.collection.filterBy("reading_level", [this.collection.levels()[i]]).length %>)</span>
                </li>
                <% } %>
            <% } %>
            </ul>
            </li>
        </ul>
        <ul class="p0">
            <li data-attribute="type"><%= app.localeManager.get("filters.type") %><i class="fa fa-caret-down" aria-hidden="true"></i>
            <ul class="p0">
            <% for (var i = 0; i < this.collection.types().length; i++) { %>
                <% if (this.collection.types()[i] !== null) { %>
                <li data-value="<%= this.collection.types()[i] %>">
                <i class="fa fa-square-o" aria-hidden="true"></i>
                <%= app.localeManager.get("types." + this.collection.types()[i].toLowerCase()) %>
                <span>(<%= this.collection.filterBy("type", [this.collection.types()[i]]).length %>)</span>
                </li>
                <% } %>
            <% } %>
            </ul>
            </li>
        </ul>
        <ul class="p0">
            <li data-attribute="format"><%= app.localeManager.get("filters.format") %><i class="fa fa-caret-down" aria-hidden="true"></i>
            <ul class="p0">
            <% for (var i = 0; i < this.collection.formats().length; i++) { %>
                <% if (this.collection.formats()[i] !== null && typeof this.collection.formats()[i] == "string") { %>
                <li data-value="<%= this.collection.formats()[i] %>">
                <i class="fa fa-square-o" aria-hidden="true"></i>
                <%= this.collection.formats()[i] %>
                <span>(<%= this.collection.filterBy("format", [this.collection.formats()[i]]).length %>)</span>
                </li>
                <% } %>
            <% } %>
            </ul>
            </li>
        </ul>
	</nav>
    <button name="resetFilters" class="reset-btn my-10"><%= app.localeManager.get("buttons.reset") %></button> 
`;

// The view for a single book model
const SearchFilterComponent = Backbone.View.extend({

	// Converts the template to html
	template: _.template( SEARCH_FILTER_TEMPLATE ),

	// The filter values are stored for future reference.
	// It is useful for updating the user's preferences
	filters: {
		"country": [],
		"format": [],
		"language": [],
		"reading_level": [],
		"theme": [],
		"type": []
	},

	events: {
		"click ul>li"                       : "expandFilter",
		"click ul>li>ul>li"                 : "filter",
		"click button[name=resetFilters]"   : "resetFilters"
	},

	initialize: function() {
		this.emptyFilters();
	},

	emptyFilters: function() {
		for (let f in this.filters) {
			this.filters[f] = [];
		}
	},

	// Returns true if the filters are all empty
	filtersAreEmpty: function() {
		for (let f in this.filters) {
			if (!_.isEmpty(this.filters[f])) {
				return false;
			}
		}
		return true;
	},

	// Expand the filter to see its values
	expandFilter: function(e) {
		let target = $(e.target).is("i") ? $(e.target).parent() : $(e.target);

		if (typeof target.attr("data-attribute") == "undefined") {
			return;
		}
		target.children().toggleClass("open");
	},

	dispatch: function(models) {
        let filterEvent = new CustomEvent("filter", {
			bubbles: true,
			detail: {
				collection: () => models
			}
        });
        
		this.el.dispatchEvent(filterEvent);
	},

	// Filter the books
	filter: function(e) {
		var books = new BookCollection();
		
		// Check or uncheck the checkbox
		// Add or remove filter elements
		this.toggle(
		    $(e.currentTarget).parent().parent().attr("data-attribute"),
            $(e.currentTarget).attr("data-value"),
            $(e.currentTarget).children("i")
        );
		if (this.filtersAreEmpty()) {
			books.set(this.collection.models);
		} else {
			// Loop through every filters and fetch the results
			// Theme A OR Theme B AND Language A OR Language B ...
			for (var property in this.filters) {
				if (this.filters.hasOwnProperty(property) && !empty(this.filters[property])) {
					books.add(this.collection.filterBy(property, this.filters[property]).models);
				}
			}
		}
		
		this.dispatch(books.clean().randomize().models);
	},

	// Render the template
	render: function() {
		var html = this.template(this.collection);
		this.$el.html(html);
		
		return this;
	},

	// Reset the filters with no values
	// Close the filter navigation bar and reset its checkboxes
	resetFilters: function() {
		// Reset the filters
		for (var property in this.filters) {
			this.filters[property] = this.filters[property].splice(0, this.length);
		}
		// Uncheck the checked checkboxes
		this.uncheck();
		// Close the opened filters
		this.$el.find("ul>li>ul.open").toggleClass("open");
		this.dispatch(this.collection.models);
	},


	// Sync the checkboxes status with the elements from the filters
	sync: function() {
		var checkboxes = this.$el.find("#search-filters>ul>li>ul>li>i");

		checkboxes.each(function(i, checkbox) {
			var value = $(checkbox).parent().attr("data-value");
			var attribute = $(checkbox).parent().parent().attr("data-attribute");

			if (!_.contains(this.filters[attribute], value)) {
				if ($(checkbox).hasClass("fa-square")) {
					$(checkbox).parent().click();
				}
			}
		});
	},

	// Toggle a checkbox with the elements from the filters
	// Add and remove elements from the filters
	toggle: function(attribute, value, target) {
		target.toggleClass("fa-square-o fa-square");

		if (_.contains(this.filters[attribute], value)) {
			this.filters[attribute].splice(this.filters[attribute].indexOf(value), 1);
		} else {
			this.filters[attribute].push(value);
		}
	},

	// Uncheck all the checkboxes
	uncheck: function() {
		this.$el.find("ul li i").removeClass("fa-square").addClass("fa-square-o");
	}
});
